
import { mapMutations, mapGetters, mapState } from "vuex";
import { RECIEVER_CHANNEL_TAB_CLICK } from "@/constants/MixpanelEvents.js";
import recieverChannelsRowCol from "./reciever-channels-row-col.vue";
import { ALL_CHANNELS } from "@/constants/Channels.js";

export default {
  components: {
    recieverChannelsRowCol
  },
  props: {
    hasChannelsPaired: {
      type: Boolean,
      default: false
    },
    showPairingTooltip: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      ALL_CHANNELS: ALL_CHANNELS,
      hasLoaded: false
    };
  },
  computed: {
    ...mapGetters("restaurant", ["getLocationChannels"]),
    ...mapState("restaurant", ["locationDetails"]),
    ...mapState("reciever", ["selectedChannel"])
  },
  created() {
    this.channelSelected(this.ALL_CHANNELS);
  },
  mounted() {
    setTimeout(() => {
      this.hasLoaded = true;
    }, 1000);
  },
  methods: {
    ...mapMutations("reciever", ["SET_SELECTED_CHANNEL"]),
    channelSelected(channel) {
      this.SET_SELECTED_CHANNEL(channel);
      this.mixPanelTrackEvent(RECIEVER_CHANNEL_TAB_CLICK, {
        channel: channel.name
      });
    },
    handleAddChannels() {
      this.$router.push(`/settings/channel-manager/`);
    }
  }
};
